/**
 * OmniBar Favorites: HQ's defaults and the parser for the synced value.
 *
 * Favorites are route KEYS (the route name without spaces, which is how the
 * library's RouterStore keys `routes`). They ride in the `user-preferences`
 * row's free-form `preferences.favorites` (see stores/settingsSync.ts), so they
 * follow the user between devices.
 */

/** Seeded on a user's first sign-in, when their preferences have no `favorites` key. */
export const HQ_DEFAULT_FAVORITES: readonly string[] = [
  "Home",
  "Dashboard",
  "ClientInstances",
  "InternalContainers",
  "Pipelines",
];

/** The library's cap on pinned pages. */
export const MAX_FAVORITES = 10;

/**
 * A synced `favorites` value as a clean key list, or `null` when it is not a
 * list at all (absent or malformed: the caller falls back). An empty list is a
 * real answer (the user removed them all) and is returned as `[]`.
 */
export function asFavorites(value: unknown): string[] | null {
  if (!Array.isArray(value)) return null;
  const keys = value.filter((k): k is string => typeof k === "string" && k.length > 0);
  return [...new Set(keys)].slice(0, MAX_FAVORITES);
}
